export const zh = {
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  selectDate: '选择日期',
  createDate: '创建日期',
  createStartDate: '创建开始日',
  createEndDate: '创建结束日',
  startDate: '开始日期',
  endDate: '结束日期',
  all: '全部',
  reset: '重置',
  search: '搜索',
  sort: '排序',
  index: '序号',
  cancel: '取消',
  upload: '上传',
  close: '关闭',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  cancelSuccess: '取消成功',
  submitSuccess: '提交成功',
  confirm: '确定',
  submit: '提交',
  uploadSuccess: '上传成功',
  uploadOnlyPdf: '上传文件只能是 PDF 格式',
  tip: '提示',
  yes: '是',
  no: '否',
  del: '删除',
  remark: '备注',
  state: '状态',
  operate: '操作',
  detail: '详情',
  home: '首页',
};

export const jp = {
  pleaseInput: '入力してください',
  pleaseSelect: 'ご選択ください。',
  selectDate: '選択日にち',
  createDate: '作成日',
  createStartDate: '作成開始日',
  createEndDate: '作成終了日',
  startDate: '開始日',
  endDate: '終了日',
  all: 'すべて',
  reset: 'リセット',
  search: '検索',
  sort: '並べ替え',
  index: 'シーケンス番号',
  cancel: 'キャンセル',
  upload: 'アップロード',
  close: '閉じる',
  saveSuccess: '保存に成功しました',
  saveFailed: '保存に失敗しました',
  cancelSuccess: 'キャンセル成功',
  submitSuccess: 'コミット成功',
  confirm: 'はい',
  submit: '送信する',
  uploadSuccess: 'アップロード成功',
  uploadOnlyPdf: 'アップロードファイルはPDF形式のみです',
  tip: 'ヒント',
  yes: 'YES',
  no: 'NO',
  del: '削除',
  remark: '備考',
  state: 'ステータス',
  operate: '操作',
  detail: '詳細',
  home: 'トップページ',
};
